// Часовые пояса IANA для выбора в карточке точки (pos.timezone).

// Если браузер не умеет Intl.supportedValuesOf — короткий список стран, где работают точки
const FALLBACK_ZONES = [
	'Asia/Tashkent', 'Asia/Samarkand', 'Asia/Almaty', 'Asia/Bishkek', 'Asia/Dushanbe',
	'Asia/Ashgabat', 'Asia/Baku', 'Asia/Tbilisi', 'Asia/Yerevan', 'Asia/Dubai',
	'Europe/Moscow', 'Europe/Istanbul', 'Europe/Kyiv', 'UTC',
]

// Смещение пояса от UTC сейчас: 'UTC+05:00'. Не удалось определить — пустая строка
function offsetLabel(zone) {
	try {
		const parts = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'longOffset' })
			.formatToParts(new Date())
		const value = parts.find(part => part.type === 'timeZoneName')?.value || ''
		if (value === 'GMT') return 'UTC+00:00'
		return value.replace('GMT', 'UTC')
	} catch (e) {
		return ''
	}
}

// Смещение в минутах на заданную дату: по нему видно, переходит ли пояс на летнее время
function offsetMinutes(zone, date) {
	const label = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'longOffset' })
		.formatToParts(date)
		.find(part => part.type === 'timeZoneName')?.value || 'GMT'
	const match = label.match(/GMT([+-])(\d{2}):?(\d{2})?/)
	if (!match) return 0
	return (match[1] === '-' ? -1 : 1) * (Number(match[2]) * 60 + Number(match[3] || 0))
}

// Пояс без перехода на летнее время: зимой и летом одинаковое смещение. Бэкенд принимает
// только такие — сдвиг границ суток постоянный
function isFixedOffset(zone) {
	try {
		const year = new Date().getFullYear()
		return offsetMinutes(zone, new Date(Date.UTC(year, 0, 1))) === offsetMinutes(zone, new Date(Date.UTC(year, 6, 1)))
	} catch (e) {
		return true
	}
}

export function timezoneOptions() {
	let zones = FALLBACK_ZONES
	try {
		if (typeof Intl.supportedValuesOf === 'function') {
			zones = Intl.supportedValuesOf('timeZone')
			// UTC в списке браузера нет, а для точки вне поясов он иногда нужен
			if (!zones.includes('UTC')) zones = [...zones, 'UTC']
		}
	} catch (e) {
		zones = FALLBACK_ZONES
	}

	return zones.filter(isFixedOffset).map(zone => {
		const offset = offsetLabel(zone)
		return { id: zone, name: offset ? `${zone} (${offset})` : zone }
	})
}
